var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaMaskFox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.625,
    height: 77.599,
    viewBox: "0 0 83.625 77.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MetaMask_Fox",
    transform: "translate(-31.3 -35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M206.84,35.5,174.6,59.445l5.962-14.127Z",
    transform: "translate(-96.53 0)",
    fill: "#e2761b",
    stroke: "#e2761b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M37.3,35.5,69.283,59.672l-5.67-14.354ZM100.13,91,91.543,104.16l18.372,5.055L115.2,91.3ZM33.9,91.3l5.249,17.918,18.372-5.055L48.935,91Z",
    transform: "translate(-1.42 0)",
    fill: "#e4761b",
    stroke: "#e4761b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M92.92,114.676,87.8,122.42l18.242.81-.648-19.6Zm36.064,0L116.346,103.4l-.421,19.83,18.21-.81ZM93.956,150.059l10.952-5.346-9.461-7.388Zm23.038-5.346,10.984,5.346-1.523-12.734Z",
    transform: "translate(-37.855 -45.899)",
    fill: "#e4761b",
    stroke: "#e4761b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M140.822,236.246,129.838,230.9l.875,7.161-.1,3.013Zm-34.022,0,10.207,4.828-.065-3.013.81-7.161Z",
    transform: "translate(-50.698 -132.086)",
    fill: "#d7c1b3",
    stroke: "#d7c1b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M119.737,181.738l-9.137-2.689,6.448-2.949Zm13.252,0,2.689-5.638,6.48,2.949Z",
    transform: "translate(-53.267 -95.043)",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M88.887,189.739l1.555-13.155-10.142.292Zm32.467-13.155,1.555,13.155,8.587-12.864Zm7.712-14.484-18.21.81,1.685,9.364,2.689-5.638,6.48,2.949Zm-38.947,7.485,6.48-2.949,2.657,5.638,1.717-9.364L82.73,162.1Z",
    transform: "translate(-32.785 -85.579)",
    fill: "#cd6116",
    stroke: "#cd6116",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M87.8,162.1,95.447,177l-.259-7.42Zm38.98,7.485-.324,7.42,7.679-14.9Zm-20.737-6.675-1.717,9.364,2.139,11.049.486-14.549Zm9.883,0-.875,5.832.389,14.581,2.171-11.049Z",
    transform: "translate(-37.855 -85.579)",
    fill: "#e4751f",
    stroke: "#e4751f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M133.022,187.889l-2.171,11.049,1.555,1.069,9.461-7.388.324-7.42ZM110.6,185.2l.259,7.42,9.461,7.388,1.555-1.069-2.139-11.049Z",
    transform: "translate(-53.267 -101.194)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M130.616,252.228l.1-3.013-.81-.713H117.687l-.745.713.065,3.013L106.8,247.4l3.564,2.916,7.226,5.022H130l7.258-5.022,3.564-2.916Z",
    transform: "translate(-50.698 -143.24)",
    fill: "#c0ad9e",
    stroke: "#c0ad9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M151,228.669l-1.555-1.069h-8.975l-1.555,1.069-.81,7.161.745-.713h12.216l.81.713Z",
    transform: "translate(-71.857 -129.856)",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M111.671,61l2.754-13.22L110.31,35.5,79.139,58.635,91.128,68.777l16.946,4.958,3.759-4.374-1.62-1.166,2.592-2.365L110.8,64.273l2.592-1.977ZM31.8,47.78,34.554,61,32.8,62.3,35.4,64.273,33.42,65.828l2.592,2.365-1.62,1.166,3.726,4.374,16.946-4.958L67.053,58.635,35.883,35.5Z",
    transform: "translate(0 0)",
    fill: "#763d16",
    stroke: "#763d16",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M109.494,94.217,92.548,89.259,97.7,97l-7.679,14.9,10.109-.13H115.2Zm-53.01-4.958L39.538,94.217,33.9,111.779H48.935l10.077.13L51.365,97ZM79.49,97.813l1.069-18.7L85.484,65.8H63.613l4.86,13.317,1.134,18.7.389,5.9.032,14.516H79l.065-14.516Z",
    transform: "translate(-1.42 -20.482)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaMaskFox);
export default __webpack_public_path__ + "static/media/MetaMask_Fox.c6f97dd3ff66fa1394ec35c0356717f6.svg";
export { ForwardRef as ReactComponent };